import delay from 'delay';
import assert from 'minimalistic-assert';
const timeoutObservers = ({ atom, timeout }) => {
    assert(atom, 'expected "atom');
    assert(typeof timeout === 'number', 'expected number "timeout"');
    const observe = (observer) => atom.observe(async (...args) => {
        const timeoutPromise = delay.reject(timeout, {
            value: new Error('Observer timed out!'),
        });
        await Promise.race([
            observer(...args),
            timeoutPromise,
        ]).finally(() => timeoutPromise.clear());
    });
    return {
        ...atom,
        observe,
    };
};
export default timeoutObservers;
